var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"outlined":"","rules":_vm.rules,"label":_vm.$t('configurations.report_difference')},model:{value:(_vm.difference),callback:function ($$v) {_vm.difference=$$v},expression:"difference"}})}
var staticRenderFns = []

export { render, staticRenderFns }